import { useEffect } from 'react';

interface UseRecommendVisibleReadEffectsParams {
  scopeKey: string;
  isEnabled: boolean;
  hasPendingRead: boolean;
  onMount(): () => void;
  onSubscribe(): () => void;
  onReconcile(): void;
  onReset(): void;
  onPoll(): void;
}

export const useRecommendVisibleReadEffects = ({
  scopeKey,
  isEnabled,
  hasPendingRead,
  onMount,
  onSubscribe,
  onReconcile,
  onReset,
  onPoll,
}: UseRecommendVisibleReadEffectsParams) => {
  useEffect(onMount, [onMount]);

  useEffect(() => {
    onReset();
  }, [onReset, scopeKey]);

  useEffect(() => {
    if (!isEnabled) return undefined;
    return onSubscribe();
  }, [isEnabled, onSubscribe, scopeKey]);

  useEffect(() => {
    onReconcile();
  }, [onReconcile]);

  useEffect(() => {
    if (!isEnabled || !hasPendingRead) return undefined;
    const intervalId = window.setInterval(onPoll, 30_000);
    return () => window.clearInterval(intervalId);
  }, [hasPendingRead, isEnabled, onPoll]);
};
